import {Component, HostBinding, OnInit, ViewChild} from "@angular/core";
import {AiProjectService} from "services/aiStudio/ai-project.service";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Config} from "global/config";
import {DatumService} from "services/aiStudio/datum.service";
import {TranslateService} from "@ngx-translate/core";
import {MINIMUM_IMAGES} from "../../../utils/project-utils";
import {TagViewService} from "services/aiStudio/tag-view.service";
import _ from "lodash";
import {TagView} from "@teamviewer/aistudioapi-aistudio-angular";
import {UploaderComponent} from "components/uploader/uploader.component";
import {EventService} from "services/event.service";

@Component({
    selector: 'import-images',
    templateUrl: 'import-images.component.html',
    styleUrls: ['import-images.component.sass']
})

export class ImportImagesComponent implements OnInit {
    @HostBinding('class') class = 'modal-content';
    @ViewChild(UploaderComponent) uploader!: UploaderComponent
    uploaderLoaded: boolean = false;
    tagViews: any = [];
    selectedTagViews: any = [];
    //detectionTags: any = []
    MINIMUM_IMAGES = MINIMUM_IMAGES;


    constructor(public aiProjectService: AiProjectService,
                public tagViewService: TagViewService,
                private modalService: NgbModal,
                private config: Config,
                private datumService: DatumService,
                private translateService: TranslateService,
                private activeModal: NgbActiveModal,
                private eventService: EventService
    ) {

    }
    async ngOnInit(){
        this.tagViews = [];
        this.selectedTagViews = [];
        this.tagViewService.selectedTagViewsForUpload = [];

        //let minIApT = MINIMUM_IMAGES;

        let backgroundTag: TagView = {};
        let positiveTags: TagView[] = [];

        if (this.aiProjectService.isSingleLabelProject()) {
            backgroundTag = _.cloneDeep(this.tagViewService.getBackgroundTagView());
            positiveTags = _.cloneDeep(this.tagViewService.getPositiveTaggedTagViews());
        } else if (this.aiProjectService.isObjectDetectionProject()) {
            // By default no tag selected
            backgroundTag = _.cloneDeep(this.tagViewService.getBackgroundWellSetTagView());
            positiveTags = _.cloneDeep(this.tagViewService.getPositiveWellSetTagViews());
        }
        for (let positiveTag of positiveTags) {
            positiveTag.selected = false;
        }

        this.tagViews = this.tagViews.concat(positiveTags);
        if(backgroundTag) {
            backgroundTag.selected = false;
            this.tagViews.push(backgroundTag);
        }
    }

    ngAfterViewInit() {
        this.uploaderLoaded = true;
    }

    checkForBackgroundTag($tag: any) {
        if(Object.is($tag.tagName, this.tagViewService.backgroundTag)) {
            this.selectedTagViews = [];
            this.selectedTagViews = [$tag.tagName];
        } else {
            if(this.selectedTagViews.includes(this.tagViewService.backgroundTag)) {
               this.selectedTagViews = this.selectedTagViews.filter((tagName: string) => !Object.is(tagName, this.tagViewService.backgroundTag));
            }
        }
        this.tagViewService.selectedTagViewsForUpload = this.selectedTagViews
    }

    removeTag($tag: any) {
        this.tagViewService.selectedTagViewsForUpload = this.selectedTagViews.filter((tagName: string) => !Object.is(tagName, $tag));
    }

    closeModal() {
        this.activeModal.close();
    };

    sendCancelEvent() {
        const projectUuid = this.aiProjectService.getAiProject().projectUuid;
        const event = this.eventService.buildModel(`Event,ai-project,cancel-upload`, projectUuid || '', '');
        this.eventService.submitEvent(event);
    }

    calculateMaximumUploadNumber() {
        let max = 0;
        for (let tag of this.tagViews) {
            if((MINIMUM_IMAGES-tag.count) > max && this.selectedTagViews.includes(tag.tagName)) {
                max = MINIMUM_IMAGES-tag.count;
            }
        }
        return max;
    };

}
